import React from 'react';
import { Button, Space } from 'antd';
import { useSelector } from 'react-redux';
import {
  MailOutlined,
  CheckCircleOutlined,
  UploadOutlined,
  FileSearchOutlined,
  DollarOutlined,
  FileProtectOutlined,
  FilePdfOutlined
} from '@ant-design/icons';
import { autorizacionesV2 } from '../../../../constants/cons';

export default function Autorizaciones({
  ordenPago,
  onAutorizar1,
  onAutorizar2,
  onAutorizar3,
  onAvanzarOP,
  onSolicitarFactura,
  onCargarFactura,
  onValidarFactura,
  onFacturaPagada,
  onCargarComplemento,
  onCargarXLSXPago,
  onCargarPDFPago,
  onCargarDocumentoConcesionados
}) {
  const { email } = useSelector((state) => state.userReducer.user);

  if (!ordenPago) return null;

  const tienePermiso = (permiso) => {
    const listaPermisos = autorizacionesV2[permiso];
    if (!listaPermisos) return true;
    return listaPermisos.includes(email);
  };

  const estaRechazada = !!ordenPago.estaRechazada;
  const estatus = ordenPago.estatusOrdenPagoID || 0;
  const total = ordenPago.total || 0;
  const tipoOP = ordenPago.tipoOP || 1;

  const requiereNivel2 = total >= 10000;
  const tieneContencion = !!ordenPago.fechaAutorizacionContencion;
  const tieneOP1 = !!ordenPago.fechaAutorizacionPago;
  const tieneOP2 = !!ordenPago.fechaAutorizacionPago2;
  const tieneSolicitudFactura = !!ordenPago.fechaSolicitudFactura;
  const tieneFacturaCargada = !!ordenPago.fechaCargaFactura;
  const tieneFacturaValidada = !!ordenPago.fechaSolicitudPago;
  const tieneFacturaPagada = !!ordenPago.fechaPagado;
  const tieneComplemento = !!ordenPago.fechaCargaComplementoPago;

  const esConcesionado = tipoOP === 3;
  const tieneDocumentoConcesionado = !!ordenPago.autorizacionClienteUri;

  const mostrarContencion = estatus === 1 && !esConcesionado && tipoOP !== 2;
  const mostrarAvanzarOP = estatus === 1 && tipoOP === 2;

  const mostrarAutorizar1 = estatus === 1 && !esConcesionado && tieneContencion;
  const mostrarAutorizar2 = estatus === 1 && !esConcesionado && tieneContencion && requiereNivel2 && tieneOP1;

  const mostrarCargarDocumentoConcesionado = estatus === 1 && esConcesionado;
  const mostrarAutorizar2Concesionado = estatus === 1 && esConcesionado;

  const mostrarSolicitarFactura = estatus === 2;

  const mostrarCargarFactura = estatus === 3;

  const mostrarValidarFactura = estatus === 4;

  const mostrarFacturaPagada = estatus === 5;
  const mostrarCargarPDF = estatus === 5;

  const mostrarCargarComplemento = estatus === 6;

  return (
    <div style={{ fontSize: '12px', lineHeight: 1.6 }}>
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        {mostrarContencion && tienePermiso('contencion') && (
          <Button
            type="primary"
            icon={<CheckCircleOutlined />}
            onClick={onAutorizar3}
            disabled={tieneContencion || estaRechazada}
            size="large"
            block
          >
            {tieneContencion ? '✓ Contención' : 'Contención'}
          </Button>
        )}

        {mostrarAvanzarOP && (
          <Button
            type="primary"
            icon={<CheckCircleOutlined />}
            onClick={onAvanzarOP}
            disabled={estaRechazada}
            size="large"
            block
          >
            Avanzar OP
          </Button>
        )}

        {mostrarAutorizar1 && tienePermiso('validacion1') && (
          <Button
            type="primary"
            icon={<CheckCircleOutlined />}
            onClick={onAutorizar1}
            disabled={tieneOP1 || estaRechazada}
            size="large"
            block
          >
            {tieneOP1 ? '✓ Autorizar' : 'Autorizar'}
          </Button>
        )}
        
        {mostrarCargarDocumentoConcesionado && (
          <Button
            type="primary"
            icon={<UploadOutlined />}
            onClick={onCargarDocumentoConcesionados}
            disabled={tieneDocumentoConcesionado || estaRechazada}
            size="large"
            block
          >
            {tieneDocumentoConcesionado ? '✓ Cargar Documento' : 'Cargar Documento'}
          </Button>
        )}
       

        {(mostrarAutorizar2 || mostrarAutorizar2Concesionado) && tienePermiso('validacion2') && (
          <Button
            type="primary"
            icon={<CheckCircleOutlined />}
            onClick={onAutorizar2}
            disabled={tieneOP2 || estaRechazada}
            size="large"
            block
          >
            {tieneOP2 ? '✓ Autorizar 2' : 'Autorizar 2'}
          </Button>
        )}

        {mostrarSolicitarFactura && (
          <Button
            type="primary"
            icon={<MailOutlined />}
            onClick={onSolicitarFactura}
            disabled={estaRechazada}
            size="large"
            block
          >
            {tieneSolicitudFactura ? '✓ Solicitar Factura' : 'Solicitar Factura'}
          </Button>
        )}

        {mostrarCargarFactura && (
          <Button
            type="primary"
            icon={<UploadOutlined />}
            onClick={onCargarFactura}
            disabled={tieneFacturaCargada || estaRechazada}
            size="large"
            block
          >
            {tieneFacturaCargada ? '✓ Cargar Factura' : 'Cargar Factura'}
          </Button>
        )}

        {mostrarValidarFactura && tienePermiso('validarFactura') && (
          <Button
            type="primary"
            icon={<FileSearchOutlined />}
            onClick={onValidarFactura}
            disabled={tieneFacturaValidada || estaRechazada}
            size="large"
            block
          >
            {tieneFacturaValidada ? '✓ Validar Factura' : 'Validar Factura'}
          </Button>
        )}

        {mostrarFacturaPagada && tienePermiso('aplicarPagos') && (
          <Button
            type="primary"
            icon={<DollarOutlined />}
            onClick={onFacturaPagada}
            disabled={tieneFacturaPagada || estaRechazada}
            size="large"
            block
          >
            {tieneFacturaPagada ? '✓ Factura Pagada' : 'Factura Pagada'}
          </Button>
        )}

        {mostrarCargarPDF && (
          <Button
            type="primary"
            icon={<FilePdfOutlined />}
            onClick={onCargarPDFPago}
            disabled={estaRechazada}
            size="large"
            block
          >
            Cargar Comprobante de Pago
          </Button>
        )}

        {mostrarCargarComplemento && (
          <Button
            type="primary"
            icon={<FileProtectOutlined />}
            onClick={onCargarComplemento}
            disabled={tieneComplemento || estaRechazada}
            size="large"
            block
          >
            {tieneComplemento ? '✓ Cargar Complemento de Pago' : 'Cargar Complemento de Pago'}
          </Button>
        )}
      </Space>
    </div>
  );
}
